import React from "react";
import { ActionRequired as ActionRequiredType} from "./dashboardType";

interface Props {
  data: ActionRequiredType;
}

const ActionRequired: React.FC<Props> = ({
  data,
}) => {
  const items = [
    [
      "Trial Expired / Not Converted",
      data.Trial_Expired_Not_Converted,
    ],

    [
      "Verification Pending",
      data.Verification_Pending,
    ],

    [
      "Delivery Issues",
      data.Delivery_Issues,
    ],

    [
      "Subscriptions Expiring Today",
      data.Subscriptions_Expiring_Today,
    ],

    [
      "Payments Pending",
      data.Payments_Pending,
    ],

    [
      "Services Starting Tomorrow",
      data.Services_Starting_Tomorrow,
    ],
  ];

  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Action Required
      </h2>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
        {items.map(
          ([label, value]) => (
            <div
              key={String(label)}
              className="flex items-center justify-between rounded-lg border p-4"
            >
              <span className="text-sm text-gray-600">
                {label}
              </span>

              <span className="ml-4 text-xl font-bold">
                {value}
              </span>
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default ActionRequired;